module.exports = require("@swa-ui/core/src/BulletList/BulletList.module.scss");